import React from "react";
import AppDataContext from "context/AppDataContext";
import MostAffectedRegionsWidget from './components/MostAffectedRegionsWidget/MostAffectedRegionsWidget';
import RiskWidget from './components/RiskWidget/RiskWidget'
import TaskCompletion from './components/TaskCompletion/TaskCompletion';
import TaskStatusWidget from './components/TaskStatusWidget/TaskStatusWidget';
import TopIssuesWidget from './components/TopIssuesWidget/TopIssuesWidget';
import RHSWidgetModal from "./components/RHSWidgetModal/RHSWidgetModal";
import NewsAndTrends from "./components/NewsAndTrends/NewsAndTrends";

import styles from './RHS.module.scss';

interface RHSType {
  tabNav: string;
  tabs: string[];
}

export default function RHS({ tabNav, tabs }: RHSType) {
  const { isRHSModalShow, setRHSModalShow } = React.useContext(AppDataContext);

  const handleClick = () => {
    setRHSModalShow(true);
  };

  const renderSwitch = () => {
    switch (tabNav) {
      case tabs[1]:
        return (
          <>
            <RiskWidget title="Risks" />
            <MostAffectedRegionsWidget />
            <NewsAndTrends />
          </>
        );
      case tabs[2]:
        return (
          <>
            <RiskWidget title="Incidents" />
            <NewsAndTrends />
            <TopIssuesWidget title="Related Risks" subTitle="Risks directly related to these incidents" />
          </>
        );
      case tabs[3]:
        return (
          <>
            <RiskWidget title="Projects" />
            <TaskStatusWidget />
            <TaskCompletion />
          </>
        );
      default:
        return (
          <>
            <RiskWidget title="Risks" />
            <TaskStatusWidget />
            <MostAffectedRegionsWidget />
            <TopIssuesWidget title="Top Issues Overall" subTitle="Description" handleClick={handleClick} />
          </>
        );
    }
  };

  return (
    <div className={styles.rightSide + ' rhs'}>
      {isRHSModalShow && <RHSWidgetModal closeModal={async () => setRHSModalShow(!isRHSModalShow)} />}
      {renderSwitch()}
    </div>
  );
}
